<template>
  <div>
    <el-tabs
    type="border-card"
    @tab-click="tabClick"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="first"
      >
        <h2 class="el_h2">基础信息</h2>
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="100px"
        class="search_form"
        >
          <el-form-item label="WMS单号:" prop="orderNo">
            <el-input placeholder="请输入WMS单号" v-model="search_form.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="交货单号:" prop="erpNo">
            <el-input placeholder="请输入交货单号" v-model="search_form.erpNo"></el-input>
          </el-form-item>
          <el-form-item label="装箱单号:" prop="traceId">
            <el-input placeholder="请输入装箱单号" v-model="search_form.traceId"></el-input>
          </el-form-item>
          <el-form-item label="设备ID:" prop="deviceId">
            <el-input placeholder="请输入设备ID" v-model="search_form.deviceId"></el-input>
          </el-form-item>
          <el-form-item label="客户名称:" prop="consigneeName">
            <el-input placeholder="请输入客户名称" v-model="search_form.consigneeName"></el-input>
          </el-form-item>
          <el-form-item label="事务状态:" prop="coldChainStatus">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.coldChainStatus"
            placeholder="请选择事务状态"
            clearable
            >
              <el-option
              v-for="item in chain_status"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="温控状态:" prop="tempFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.tempFlag"
            placeholder="请选择温控状态"
            clearable
            >
              <el-option
              v-for="item in temp_status"
              :key="item.value"
              :label="item.name"
              :value="item.name"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签回状态:" prop="signBackFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.signBackFlag"
            placeholder="请选择签回状态"
            clearable
            >
              <el-option label="已签回" value="Y"></el-option>
              <el-option label="未签回" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次ID:" prop="lotId">
            <el-input placeholder="请输入批次ID" v-model="search_form.lotId"></el-input>
          </el-form-item>
          <el-form-item label="开始时间从" prop="order_time">
            <el-date-picker
            type="daterange"
            v-model="search_form.order_time"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
            @change="order_time_change"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到达时间从" prop="arrive_time">
            <el-date-picker
            type="daterange"
            v-model="search_form.arrive_time"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
            @change="arrive_time_change"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签回时间从" prop="back_time">
            <el-date-picker
            type="daterange"
            v-model="search_form.back_time"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
            @change="back_time_change"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="数据是否存在:" prop="dataFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.dataFlag"
            placeholder="请选择"
            clearable
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
          v-if="btn_permission.includes('middle:coldChain:rent')||btn_permission.includes('superAdmin')"
          label="特殊箱型:"
          prop="traceType">
            <el-switch
            v-model="search_form.traceType"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
            @click="search_cold(true)"
            type="primary"
            v-if="btn_permission.includes('middle:coldChain:list')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            v-if="btn_permission.includes('middle:coldChain:list')||btn_permission.includes('superAdmin')"
            @click="reset_cold">重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="second"
      >
        <el-table
        ref="manage_table"
        v-loading="list_loading"
        :data="listData"
        highlight-current-row
        border
        @row-click="left_click"
        @row-contextmenu="right_click"
        max-height="500"
        >
          <el-table-column fixed="left" type="selection"></el-table-column>
          <el-table-column type="index" align="center" label="NO"></el-table-column>
          <el-table-column
          align="center"
          min-width="160"
          sortable
          prop="orderNo"
          show-overflow-tooltip
          label="WMS单号"></el-table-column>
          <el-table-column
          align="center"
          min-width="120"
          sortable
          prop="erpNo"
          show-overflow-tooltip
          label="交货单号"></el-table-column>
          <el-table-column
          align="center"
          min-width="200"
          prop="traceId"
          show-overflow-tooltip
          label="装箱单号"></el-table-column>
          <el-table-column
          align="center"
          min-width="100"
          prop="deviceId"
          show-overflow-tooltip
          label="设备ID"></el-table-column>
          <el-table-column
          align="center"
          min-width="200"
          prop="consigneeName"
          label="客户名称"></el-table-column>
          <el-table-column
          align="center"
          min-width="80"
          prop="tempFlag"
          label="温度要求"></el-table-column>
          <el-table-column
          align="center"
          min-width="160"
          sortable
          prop="startTime"
          show-overflow-tooltip
          label="开始时间"></el-table-column>
          <el-table-column
          align="center"
          min-width="160"
          sortable
          prop="arriveTime"
          show-overflow-tooltip
          label="到达时间"></el-table-column>
          <el-table-column
          align="center"
          min-width="160"
          sortable
          prop="backTime"
          show-overflow-tooltip
          label="签回时间"></el-table-column>
          <el-table-column
          align="center"
          prop="carrierId"
          label="承运人"
          min-width="100"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="carrierNum"
          min-width="100"
          label="运单号"
          ></el-table-column>
          <el-table-column
          align="center"
          min-width="110"
          fixed="right"
          label="事务状态">
            <template slot-scope="scope">
              <span v-if="scope.row.coldChainStatus==1">未绑定</span>
              <span v-else-if="scope.row.coldChainStatus==2">未处理</span>
              <span v-else-if="scope.row.coldChainStatus==4">待处理</span>
              <span v-else>已处理</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 冷链列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="pageparm_size_change"
        @current-change="pageparm_current_change"
        :current-page="pageparm.currentPage"
        :page-sizes="[10, 15, 20, 25,50,100]"
        :page-size="pageparm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageparm.total"
        ></el-pagination>
        <!-- 温度计右键菜单 -->
        <div id="menu">
          <ul>
            <li @click="bin_device_pre" v-if="btn_permission.includes('middle:coldChain:bindDevice')||btn_permission.includes('superAdmin')">
              <span>绑定设备</span>
            </li>
            <li @click="confirm_time_pre" v-if="btn_permission.includes('middle:coldChain:confirmArrived')||btn_permission.includes('superAdmin')">
              <span>确认到达时间</span>
            </li>
            <li @click="check_temp" v-if="btn_permission.includes('middle:coldChain:getTempData')||btn_permission.includes('superAdmin')">
              <span>查看温度</span>
            </li>
            <li @click="info_click" v-if="btn_permission.includes('middle:coldLot:list')||btn_permission.includes('superAdmin')">
              <span>添加到批次</span>
            </li>
            <!-- <li @click="confirm_time_now" v-if="btn_permission.includes('middle:coldChain:confirmArrived')||btn_permission.includes('superAdmin')">
              <span>确认当前到达</span>
            </li> -->
          </ul>
        </div>
        <!-- 冷链车右键菜单 -->
        <div id="truck_menu">
          <ul>
            <li @click="check_truck_temp">
              <span>查看温度</span>
            </li>
          </ul>
        </div>
        <!-- 冷链车查询温度数据弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="truck_time_show"
        title="查询温度数据"
        v-dialogDrag
        >
          <el-form
          :model="truck_form"
          label-width="80px"
          class="truck_form"
          >
            <el-form-item label="时间范围:" prop="truck_date">
              <el-date-picker
              style="width: 100%;"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              v-model="truck_form.truck_date"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              @change="truck_date_change"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="truck_form_btn">
              <el-button @click="truck_time_show=false">取消</el-button>
              <el-button type="primary" @click="confirm_arrive_time">确认</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 绑定温度计弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="device_show"
        title="绑定温度计"
        width="80%"
        v-dialogDrag
        >
          <el-form
          ref="bind_form"
          :model="bind_form"
          label-width="80px"
          class="bind_form"
          >
            <el-form-item label="设备ID" prop="deviceId">
              <el-input placeholder="请输入设备ID" v-model="bind_form.deviceId"></el-input>
            </el-form-item>
            <el-form-item label="到达时间" prop="startTimeStr">
              <el-date-picker
              style="width: 100%;"
              type="datetime"
              placeholder="选择到达时间"
              v-model="bind_form.startTimeStr"
              value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="返回时间" prop="signBackTimeStr">
              <el-date-picker
              style="width: 100%;"
              type="datetime"
              placeholder="选择返回时间"
              v-model="bind_form.signBackTimeStr"
              value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search_device">搜索</el-button>
            </el-form-item>
          </el-form>
          <!-- 设备列表 -->
          <el-table
          v-loading="device_loading"
          :data="bind_device_list"
          highlight-current-row
          max-height="300"
          >
            <el-table-column align="center" type="index" label="NO"></el-table-column>
            <el-table-column
            align="center"
            show-overflow-tooltip
            label="设备编号"
            prop="deviceId"
            ></el-table-column>
            <el-table-column
            align="center"
            show-overflow-tooltip
            label="设备名称"
            prop="deviceName"
            ></el-table-column>
            <el-table-column
            align="center"
            show-overflow-tooltip
            label="设备型号"
            prop="deviceSpec"
            ></el-table-column>
            <el-table-column
            label="操作"
            align="center"
            >
              <template slot-scope="scope">
                <el-button
                size="mini"
                type="infor"
                @click="bin_device(scope.row)" v-if="btn_permission.includes('middle:coldChain:bindDevice')||btn_permission.includes('superAdmin')">绑定</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 设备列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="pageparms_size_change"
          @current-change="pageparms_current_change"
          :current-page="pageparms.currentPage"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pageparms.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageparms.total"
          ></el-pagination>
        </el-dialog>
        <!-- 确认到达时间弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="arrive_time_show"
        title="确认到达时间"
        v-dialogDrag
        >
          <el-form
          :model="arrive_form"
          label-width="80px"
          class="arrive_form"
          >
            <el-form-item label="到达时间:" prop="arriveTime">
              <el-date-picker
              style="width: 100%;"
              type="datetime"
              placeholder="选择到达时间"
              v-model="arrive_form.arriveTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="arrive_form_btn">
              <el-button @click="arrive_time_show=false">取消</el-button>
              <el-button type="primary" @click="confirm_time">确认</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane
      label="温度数据"
      name="third"
      style="overflow-x: auto;"
      >
        <!-- echarts曲线数据 -->
        <div id="chart" ref="my_echarts" v-show="chart_or_draw==false">
          <canvas></canvas>
        </div>
        <!-- 手绘曲线数据 -->
        <div style="text-align: center;" class="controlToEdit" v-show="chart_or_draw==true">
          <div style="margin-bottom: 15px;">
            <span>当前鼠标所在温度:{{mouseCurrentTemp}}</span>
            <el-button size="mini" type="warning" class="reDrawing" @click="reDrawing()">重画</el-button>
            <el-button size="mini" type="success" class="confirmDrawing" @click="confirmDrawing()">确认</el-button>
            <el-button size="mini" class="backToCharts" @click="reBack()">返回</el-button>
          </div>
          <canvas
          id="manualDrawingCanvas"
          width="1000"
          height="400"
          style="border:1px solid black;zoom: 1.25;"></canvas>
        </div>
        <div v-if="row_cold_now.tempFlag!='N'" class="chart_btn_group">
          <el-switch
          v-model="save_alert"
          active-value='Y'
          inactive-value='N'
          v-if="btn_permission.includes('middle:coldChain:delAlert')||btn_permission.includes('superAdmin')"
          ></el-switch>
          <i :title="draw_title"
          :class="{'draw_edit_ture':draw_status==true}"
          class="el-icon-edit"
          v-if="btn_permission.includes('middle:coldChain:draw')||btn_permission.includes('superAdmin')"
          @click="draw_curve"></i>
          <i title="保存数据"
          class="el-icon-folder-checked"
          v-if="btn_permission.includes('middle:coldChain:exactTempData')||btn_permission.includes('superAdmin')"
          @click="save_data"></i>
          <i title="导出温度数据"
          class="el-icon-printer"
          v-if="btn_permission.includes('middle:coldChain:exportPdf')||btn_permission.includes('superAdmin')"
          @click="export_data"></i>
          <i title="曲线明细"
          class="el-icon-document"
          @click="get_temperature_list"></i>
        </div>
        <div v-if="row_cold_now.tempFlag=='N'" class="chart_btn_group">
          <i title="曲线明细"
          class="el-icon-document"
          v-if="truck_detail_show==true"
          @click="get_truck_list"></i>
        </div>
        <!-- 温度计曲线明细弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="curve_temp_show"
        :title="row_cold_now.traceId+' 的曲线明细'"
        v-dialogDrag
        >
          <el-table
          :data="curve_temp_data"
          highlight-current-row
          border
          max-height="500"
          >
            <el-table-column
            align="center"
            prop="recordTime"
            label="时间"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="temperature"
            label="温度(°C)"
            ></el-table-column>
          </el-table>
        </el-dialog>
        <!-- 冷链车曲线明细弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="curve_truck_show"
        :title="temperature_name+' 的曲线明细'"
        v-dialogDrag
        >
          <el-table
          :data="curve_truck_data"
          highlight-current-row
          border
          max-height="500"
          >
            <el-table-column
            align="center"
            prop="recordTime"
            label="时间"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="temperature"
            label="温度(°C)"
            ></el-table-column>
          </el-table>
        </el-dialog>
        <!-- 手动确认温度弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="draw_show"
        title="手动确认温度"
        :before-close="confirm_temp_close"
        v-dialogDrag
        >
          <el-form
          :model="draw_temp_form"
          ref="draw_temp_form"
          label-width="80px"
          >
            <el-form-item label="温度上限" prop="maxT">
              <el-input type="number" placeholder="温度上限" v-model="draw_temp_form.maxT"></el-input>
            </el-form-item>
            <el-form-item label="温度下限" prop="minT">
              <el-input type="number" placeholder="温度下限" v-model="draw_temp_form.minT"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirm_temp_save">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 确认始末温度弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="had_temp_show"
        title="确认始末温度"
        :before-close="had_temp_close"
        v-dialogDrag
        >
          <el-form
          :model="had_temp_form"
          ref="had_temp_form"
          label-width="80px"
          >
            <el-form-item label="最初温度:">
              <el-input type="number" autocomplete="off" v-model="had_temp_form.fp"></el-input>
            </el-form-item>
            <el-form-item label="最末温度:">
              <el-input type="number" autocomplete="off" v-model="had_temp_form.lp"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirm_had_temp">确认</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 导出温度数据弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="export_data_show"
        :title="export_data_title"
        width="80%"
        class="export_dialog"
        v-dialogDrag
        >
          <el-form
          :model="export_data_form"
          ref="export_data_form"
          class="export_data_form"
          label-width="120px"
          >
            <el-form-item label="刻度">
              <el-radio-group v-model="export_data_form.time">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="5">5分钟</el-radio>
                <el-radio :label="10">10分钟</el-radio>
                <el-radio :label="30">30分钟</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="time_item" label="时间范围">
              <el-date-picker
              style="width: 45%;"
              type="datetime"
              placeholder="选择开始时间"
              v-model="export_data_form.sF"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsStart"
              ></el-date-picker>
              <el-date-picker
              style="width: 45%;"
              type="datetime"
              placeholder="选择到达时间"
              v-model="export_data_form.toto"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsEnd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-success" @click="check_export_data">确认</el-button>
              <el-button icon="el-icon-download" @click="export_data_pdf">导出</el-button>
            </el-form-item>
          </el-form>
          <!-- 要导出的echarts曲线数据 -->
          <div id="export_chart">
            <canvas></canvas>
          </div>
        </el-dialog>
        <!-- 批次弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="insert_batch_show"
        title="选择批次"
        v-dialogDrag
        >
          <el-form
          :inline="true"
          ref="insert_batch_form"
          >
            <el-form-item>
              <el-input placeholder="输入批次名" v-model="batch_name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
              type="primary"
              v-if="btn_permission.includes('middle:coldLot:add')||btn_permission.includes('superAdmin')"
              @click="create_batch">点击创建新的批次</el-button>
            </el-form-item>
          </el-form>
          <!-- 批次列表 -->
          <el-table
          :data="batch_list"
          ref="batch_table"
          highlight-current-row
          max-height="300"
          @row-click="batch_left_click"
          @row-contextmenu="batch_right_click"
          >
            <el-table-column align="center" type="index" label="NO"></el-table-column>
            <el-table-column
            align="center"
            width="200"
            sortable
            prop="lotName"
            show-overflow-tooltip
            label="批次名"></el-table-column>
            <el-table-column
            align="center"
            sortable
            prop="count"
            label="包含数"></el-table-column>
            <el-table-column
            align="center"
            sortable
            prop="addWho"
            show-overflow-tooltip
            label="创建人"></el-table-column>
            <el-table-column
            align="center"
            sortable
            prop="addTime"
            show-overflow-tooltip
            label="创建时间"></el-table-column>
          </el-table>
          <!-- 批次列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="batch_size_change"
          @current-change="batch_current_change"
          :current-page="batch_current_page"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="batch_page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="batch_total"
          ></el-pagination>
          <!-- 批次列表右键菜单 -->
          <div id="batch_menu">
            <ul>
              <li @click="add_now_batch" v-if="btn_permission.includes('middle:coldLot:addDetail')||btn_permission.includes('superAdmin')">
                <span>添加到该批次</span>
              </li>
            </ul>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { Menu } from 'element-ui'
  import Pagination from '../Pagination'
  import Paginations from '../Pagination_new'
  export default {
    name:'manage',
    data() {
      return{
        //路由传参
        router_params:{},
        //权限数组
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //事务状态下拉框
        chain_status:[],
        //温控状态下拉框
        temp_status:[],
        //切换tab
        activeName:'first',
        //冷链列表
        listData:[],
        //冷链列表懒加载
        list_loading:false,
        row_index:0,
        //冷链列表分页
        pageparm:{
          currentPage: 1,
          pageSize: 50,
          total: 10
        },
        //冷链事务列表查询表单
        search_form:{
          order_time:'',
          arrive_time:'',
          back_time:'',
          orderNo:'',
          erpNo:'',
          traceId:'',
          deviceId:'',
          consigneeName:'',
          orderTimeBegin:'',
          orderTimeEnd:'',
          arriveTimeBegin:'',
          arriveTimeEnd:'',
          backTimeBegin:'',
          backTimeEnd:'',
          coldChainStatus:'',
          tempFlag:'',
          signBackFlag:'',
          lotId:'',
          dataFlag:'',
          traceType:false
        },
        //冷链列表当前行数据
        row_cold_now:[],
        //绑定温度计弹框
        //绑定温度计弹框显影
        device_show:false,
        //设备搜索表单
        bind_form:{
          deviceId:'',
          startTimeStr:'',
          signBackTimeStr:'',
          warehouseId:''
        },
        //设备列表
        bind_device_list:[],
        //设备列表懒加载
        device_loading:false,
        //设备列表分页
        pageparms:{
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //冷链车查询温度数据弹框
        truck_time_show:false,
        truck_form:{
          truck_date:''
        },
        //限定冷链车时间范围在一个月内
        truck_select_date:'',
        pickerOptions:{
          onPick:({maxDate,minDate})=>{
            this.truck_select_date=minDate.getTime()
            if(maxDate){
              this.truck_select_date=''
            }
          },
          disabledDate:(time)=>{
            if(this.truck_select_date!=''){
              const one=30*24*3600*1000
              const minTime=this.truck_select_date-one
              const maxTime=this.truck_select_date+one
              return time.getTime()<minTime||time.getTime()>maxTime
            }
          }
        },
        //确认到达时间弹框
        //确认到达时间弹框显影
        arrive_time_show:false,
        //确认到达时间表单
        arrive_form:{
          arriveTime:''
        },
        //温度数据相关
        //echarts实例
        myChart:'',
        //echarts曲线图和手绘板的显影
        chart_or_draw:false,
        //温度上限
        maxTemperature:0,
        //温度下限
        minTemperature:0,
        //获取该温度数据时，是否为客制曲线
        globalCustomFlag:'N',
        //是否为手绘
        isCustom:'N',
        //手绘是否结束
        hasOver:'Y',
        //保存温度数据是否删除报警信息
        save_alert:'',
        //绘制按钮点击状态
        draw_status:false,
        draw_title:'绘制曲线',
        //获取温度数据
        tempData:{},
        //时间戳和温度数组
        new_temp_list:[],
        //手动确认温度弹框显影
        draw_show:false,
        //手动确认温度表单
        draw_temp_form:{
          maxT:-18,
          minT:-80
        },
        drawXPoint:[],
        drawYPoint:[],
        sTime:'',
        eTime:'',
        timeInterval:60,
        marginLeft:50,
        inclusiveAmount:2,//包容量。用于打点的时候允许像素偏差范围
        canvas:'',
        cxt:'',//画板绘图对象
        canvasWidth:'',//画板宽度
        canvasHeight:'',//画板高度
        totalPoint:0,//总共需要’打点‘的坐标数量
        currentPoint:'',//当前第几个点
        shouldPoint:1,//应该打第几个点
        shouldBeIndex:0,//应该去哪个坐标
        interval:'',//间隔量，用于计算下一x轴位置
        isMouseDown:false,//鼠标是否为按下状态
        mouseCurrentTemp:0,//当前鼠标所在温度
        savedStatus:-1,//事务状态
        // 确认始末温度弹框
        had_temp_show:false,
        had_temp_form:{
          fp:'',
          lp:''
        },
        // imgUrl:'',
        // md5:'',
        //导出温度数据弹框
        export_data_show:false,
        export_data_title:'',
        export_data_form:{
          time:'',
          sF:'',
          toto:''
        },
        //限定开始时间必须小于结束时间
        pickerOptionsStart:{
          disabledDate:(time)=>{
            if(!this.export_data_form.toto){
              return false
            }
            let preDate=new Date(this.export_data_form.sF).getTime()
            let nextDate=new Date(this.export_data_form.toto).getTime()
            return time.getTime()>nextDate+24*3600*1000||time.getTime()<preDate-24*3600*1000
          }
        },
        //限定结束时间必须大于开始时间
        pickerOptionsEnd:{
          disabledDate:(time)=>{
            if(!this.export_data_form.sF){
              return false
            }
            let preDate=new Date(this.export_data_form.sF).getTime()
            let nextDate=new Date(this.export_data_form.toto).getTime()
            return time.getTime()>nextDate+24*3600*1000||time.getTime()<preDate-24*3600*1000
          }
        },
        //要导出的echarts曲线数据
        export_chart_show:false,
        //导出echarts实例
        export_chart:'',
        pdfUrl:'',
        //批次弹框
        lotList:[],
        insert_batch_show:false,
        batch_name:'',
        batch_list:[],
        row_batch_now:[],
        //批次列表分页
        batch_current_page:1,
        batch_page_size:10,
        batch_total:10,
        //温度计曲线明细弹框
        curve_temp_show:false,
        curve_temp_data:[],
        curve_temp_list:[],
        //冷链车曲线明细弹框
        curve_truck_show:false,
        truck_detail_show:false,
        curve_truck_data:[],
        curve_truck_list:[],
        temperature_name:''
      }
    },
    //注册组件
    components:{
      Pagination,
      Paginations
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //事务状态下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/middle/coldChain/select/transactionStatus'
      }).then(data=>{
        if(data.data.success==true){
          that.chain_status=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //温控状态下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/TempControlLabel'
      }).then(data=>{
        if(data.data.success==true){
          that.temp_status=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //路由传参
      if(that.$route.query.row){
        that.router_params=that.$route.query.row
        if(that.router_params.deviceType==1){//冷链车
          that.$nextTick(()=>{
            that.search_form.traceId=''
            that.search_form.deviceId=that.router_params.deviceId
            that.truck_form.truck_date=[that.router_params.warnTime+' 00:00:00',
            that.router_params.warnTime+' 23:59:59']
            //查询冷链事务列表
            that.search_cold()
          })
        }else if(that.router_params.deviceType==2){//温度计
          that.$nextTick(()=>{
            that.search_form.deviceId=''
            that.search_form.traceId=that.router_params.traceId
            //查询冷链事务列表
            that.search_cold()
          })
        }
      }
    },
    mounted() {

    },
    watch:{
      '$route'(to,from){
        let that=this
        if(to.name=='manage'&&that.$route.query.row){
          that.router_params=that.$route.query.row
          if(that.router_params.deviceType==1){//冷链车
            that.search_form.traceId=''
            that.search_form.deviceId=that.router_params.deviceId
            that.truck_form.truck_date=[that.router_params.warnTime+' 00:00:00',
            that.router_params.warnTime+' 23:59:59']
            //查询冷链事务列表
            that.search_cold()
          }else if(that.router_params.deviceType==2){//温度计
            that.search_form.deviceId=''
            that.search_form.traceId=that.router_params.traceId
            //查询冷链事务列表
            that.search_cold()
          }
        }
      }
    },
    methods:{
      //切换标签页
      tabClick(tab){

      },
      //冷链事务列表
      coldChain_list(){  
        let that=this
        that.list_loading=true
        that.$axios.get(that.publicAjax.extra_path+'/middle/coldChain/list',{
          params:{
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize,
            orderNo:that.search_form.orderNo,
            erpNo:that.search_form.erpNo,
            traceId:that.search_form.traceId,
            deviceId:that.search_form.deviceId,
            consigneeName:that.search_form.consigneeName,
            orderTimeBegin:that.search_form.orderTimeBegin,
            orderTimeEnd:that.search_form.orderTimeEnd,
            arriveTimeBegin:that.search_form.arriveTimeBegin,
            arriveTimeEnd:that.search_form.arriveTimeEnd,
            backTimeBegin:that.search_form.backTimeBegin,
            backTimeEnd:that.search_form.backTimeEnd,
            coldChainStatus:that.search_form.coldChainStatus,
            tempFlag:that.search_form.tempFlag,
            signBackFlag:that.search_form.signBackFlag,
            lotId:that.search_form.lotId,
            dataFlag:that.search_form.dataFlag,
            traceType:that.search_form.traceType
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            var menu=document.querySelector('#menu')
            var truck_menu=document.querySelector('#truck_menu')
            menu.style.display='none'
            truck_menu.style.display='none'
            //重置手绘按钮点击状态
            that.draw_status=false
            that.chart_or_draw=false
            that.draw_title='绘制曲线'
            that.listData=data.data.data.list
            // if(that.listData.length>0){
            //   that.row_cold_now=data.data.data.list[0]
            // }
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //开始时间change事件
      order_time_change(value){
        if(value!=null){
          this.search_form.orderTimeBegin=value[0]
          this.search_form.orderTimeEnd=value[1]
        }else{
          this.search_form.orderTimeBegin=''
          this.search_form.orderTimeEnd=''
        }
      },
      //到达时间change事件
      arrive_time_change(value){
        if(value!=null){
          this.search_form.arriveTimeBegin=value[0]
          this.search_form.arriveTimeEnd=value[1]
        }else{
          this.search_form.arriveTimeBegin=''
          this.search_form.arriveTimeEnd=''
        }
      },
      //签回时间change事件
      back_time_change(value){
        if(value!=null){
          this.search_form.backTimeBegin=value[0]
          this.search_form.backTimeEnd=value[1]
        }else{
          this.search_form.backTimeBegin=''
          this.search_form.backTimeEnd=''
        }
      },
      //冷链事务列表分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //冷链事务列表
        this.coldChain_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //冷链事务列表
        this.coldChain_list()
      },
      //查询冷链事务列表
      search_cold(router_status){
        if(router_status==true){
          let now_date=this.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd')
          this.truck_form.truck_date=[now_date+' 00:00:00',now_date+' 23:59:59']
        }
        this.pageparm.currentPage=1
        this.pageparm.pageSize=50
        this.activeName='second'
        //冷链事务列表
        this.coldChain_list()
      },
      //重置冷链事务查询表单
      reset_cold(){
        this.search_form.orderTimeBegin=''
        this.search_form.orderTimeEnd=''
        this.search_form.arriveTimeBegin=''
        this.search_form.arriveTimeEnd=''
        this.search_form.backTimeBegin=''
        this.search_form.backTimeEnd=''
        this.$refs['search_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=50
        //冷链事务列表
        this.coldChain_list()
      },
      //冷链列表鼠标左键点击事件
      left_click(row,column,event){
        var menu=document.querySelector('#menu')
        var truck_menu=document.querySelector('#truck_menu')
        menu.style.display='none'
        truck_menu.style.display='none'
      },
      //冷链列表鼠标右键点击事件
      right_click(row,column,event){
        this.row_cold_now=row
        event.preventDefault()
        if(row.tempFlag=='N'){
          var menu=document.querySelector('#truck_menu')
          var truck_menu=document.querySelector('#menu')
          menu.style.top=event.clientY+60+'px'
        }else{
          var menu=document.querySelector('#menu')
          var truck_menu=document.querySelector('#truck_menu')
          menu.style.top=event.clientY+'px'
        }
        truck_menu.style.display='none'
        //根据事件对象中鼠标点击的位置，进行定位
        let menu_top=document.body.clientHeight-event.clientY
        menu.style.left=event.clientX+'px'
        //改变自定义菜单的显示和隐藏
        menu.style.display='block'
        //获取当前右键点击的table下标
        this.listData.forEach((item,index)=>{
          if(item.id==row.id){
            this.row_index=index
            return false
          }
        })
        this.$refs['manage_table'].setCurrentRow(row)
      },
      //冷链车时间范围change事件
      truck_date_change(value){

      },
      //冷链车确认温度前置
      check_truck_temp(){
        var truck_menu=document.querySelector('#truck_menu')
        truck_menu.style.display='none'
        this.truck_time_show=true
      },
      //冷链车查询温度数据弹框
      confirm_arrive_time(){
        let that=this
        if(that.truck_form.truck_date==''||that.truck_form.truck_date==null){
          that.$message.warning('请选择开始时间和结束时间')
        }else{
          that.truck_time_show=false
          that.$axios({
            method:'get',
            url:that.publicAjax.extra_path+'/middle/coldChain/driveData',
            params:{
              beginTime:this.truck_form.truck_date[0],
              endTime:this.truck_form.truck_date[1],
              deviceId:this.row_cold_now.deviceId
            },
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              if(data.data.data!=null){
                if(data.data.data.length==1){
                  this.temperature_name=data.data.data[0][0].deviceId
                  this.truck_detail_show=true
                }else{
                  this.truck_detail_show=false
                }
                //获取冷链车温度数据
                that.get_truck_temp(data.data.data)
              }
            }else{
              that.$message.error(data.data.message)
            }
          })
        }
      },
      //获取冷链车温度数据
      get_truck_temp(data_list){
        //初始化echarts实例
        document.getElementById('chart').removeAttribute('_echarts_instance_')
        this.myChart=this.$echarts.init(document.getElementById('chart'))
        this.myChart.clear()
        this.activeName='third'
        let that=this
        that.curve_truck_list=[]
        let series_old_list=[],series_new_list=[],
        yAxis_list=[],xAxis_list=[]
        let data_temp_list=data_list
        data_temp_list.forEach((item,index)=>{
          series_old_list.push([])
          that.curve_truck_list.push([])
          item.forEach((item1,index1)=>{
            item1.recordTime=that.publicAjax.genDateFromStamp(item1.recordTime)
            item1.temperature=parseFloat(item1.temperature).toFixed(1)
            series_old_list[index].push([item1.recordTime,item1.temperature])
            that.curve_truck_list[index].push({
              recordTime:item1.recordTime,
              temperature:item1.temperature
            })
          })
          xAxis_list.push({
            type:'category',
            axisLine: {
              onZero: false
            },
            showMaxLable:true,//显示最大值
            showMinLable:true,//显示最小值
            axisTick: {
              alignWithLabel: true
            }
          })
          yAxis_list.push({
            type:'value',
            axisLine:{onZero:false}
            // max:parseFloat(item[0].maxTemp)+2,//y轴最大值
            // min:parseFloat(item[0].minTemp)-2//y轴最小值
          })
          series_new_list.push({
            name:item[0].deviceId,
            id:'a'+index,
            type:'line',
            smooth:true,
            emphasis: {
              focus: 'series'
            },
            data:series_old_list[index]
          },{//温度下限(有效范围)
            id:'b'+index,
            type:'line',
            smooth:false,
            itemStyle: {
                normal: {
                    lineStyle: {
                        color:'green',
                        width: 2,
                        type: 'dotted'  //'dotted'虚线 'solid'实线
                    }
                }
            },
            data:[[series_old_list[index][0][0],parseFloat(item[0].minTemp)],[series_old_list[index][series_old_list[index].length-1][0],parseFloat(item[0].minTemp)]]
          },{//温度上限(有效范围)
            id:'c'+index,
            type:'line',
            smooth:false,
            itemStyle: {
                normal: {
                    lineStyle: {
                        color:'yellow',
                        width: 2,
                        type: 'dotted'  //'dotted'虚线 'solid'实线
                    }
                }
            },
            data:[[series_old_list[index][0][0],parseFloat(item[0].maxTemp)],[series_old_list[index][series_old_list[index].length-1][0],parseFloat(item[0].maxTemp)]]
          })
        })
        let option={
          legend: {},
          xAxis:xAxis_list,
          yAxis:yAxis_list,
          dataZoom:[
            {
                id: 'dataZoomX',
                type: 'inside',
                xAxisIndex: [0],
                filterMode: 'filter'
            },
            {
                id: 'dataZoomY',
                type: 'inside',
                yAxisIndex: [0],
                filterMode: 'empty'
            },
            {
                id: 'dataZoomXs',
                type: 'slider'
                , show: true
                , xAxisIndex: [0]
                , filterMode: 'filter'
                , textStyle: {
                    color: "#409EFF"
                    , fontWeight: 'lighter'
                    , fontStyle: 'italic'
                    , width: 30
                    , fontSize: 9
                    , overflow: "break"
                }
            },
            {
                id: 'dataZoomYs',
                type: 'slider',
                yAxisIndex: [0],
                filterMode: 'empty'
                , textStyle: {
                    color: "#409EFF", width: '2', overflow: "truncate"
                }
            }
          ],
          series:series_new_list,
          tooltip:{
            trigger: 'axis',
            //表示不使用默认的【显示】【隐藏】触发规则
            axisPointer:{
              type:'cross',
              snap:true,
              label:{
                backgroundColor:'#6a7985',
                precision:1
              }
            },
            formatter:function(params){
              let res=params[0].data[0]+'<br>'
              for(var i=0;i<params.length;i++){
                if(params[i].seriesId.indexOf('a')!=-1){
                  res+= params[i].marker+params[i].seriesName+'<br>'+"温度："+parseFloat(params[i].data[1]).toFixed(1)+"°c<br>"
                }
              }
              return res
            }
          },
          toolbox:{
            show:true,
            feature:{
              saveAsImage: {
                  show: true,
                  excludeComponents: ['toolbox'],
                  pixelRatio: 2
              }
            }
          }
        }
        that.myChart.setOption(option)
        that.myChart.on('legendselectchanged',(params)=>{
          let selected_item=[]
          for(let key in params.selected){
            if(params.selected[key]==true){
              selected_item.push({
                label:key,
                value:params.selected[key]
              })
            }
          }
          if(selected_item.length==1){
            that.curve_truck_list=[]
            that.truck_detail_show=true
            data_temp_list.forEach(item=>{
              if(selected_item[0].label==item[0].deviceId){
                //温度数据名称
                that.temperature_name=item[0].deviceId
                item.forEach(item1=>{
                  that.curve_truck_list.push({
                    recordTime:item1.recordTime,
                    temperature:item1.temperature
                  })
                })
              }
            })
          }else{
            that.truck_detail_show=false
          }
        })
      },
      //绑定设备前置
      //绑定设备菜单点击事件
      bin_device_pre(){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
        if(this.row_cold_now.deviceId!=''){
          this.$message.warning('该事务已绑定设备！')
          return false
        }
        this.device_show=true
        this.bind_device_list=[]
        this.pageparms.total=0
        this.bind_form.warehouseId=this.row_cold_now.warehouseId
        //设置设备搜索表单初始值
        if(this.row_cold_now.startTime==null){
          this.bind_form.startTimeStr='1970-01-01 08:00:00'
          this.bind_form.signBackTimeStr='1970-01-01 08:00:00'
        }else{
          this.bind_form.startTimeStr=this.row_cold_now.startTime
          this.bind_form.signBackTimeStr=this.row_cold_now.startTime
        }
      },
      //搜索设备
      search_device(){
        if(!this.bind_form.startTimeStr){
          this.$message.warning('请选择开始时间！')
          return false
        }
        if(!this.bind_form.signBackTimeStr){
          this.$message.warning('请选择返回时间！')
          return false
        }
        if(this.bind_form.startTimeStr>this.bind_form.signBackTimeStr){
          this.$message.warning('开始时间必须小于或等于返回时间')
          return false
        }
        this.pageparms.currentPage=1
        this.pageparms.pageSize=10
        //设备列表
        this.device_list()
      },
      //设备列表
      device_list(){
        let that=this
        that.device_loading=true
        that.$axios.get(that.publicAjax.extra_path+'/middle/coldChain/getDevice?page='+that.pageparms.currentPage+'&limit='+that.pageparms.pageSize,{
          params:that.bind_form
        }).then(data=>{
          that.device_loading=false
          if(data.data.success==true){
            that.bind_device_list=data.data.data.list
            that.pageparms.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //设备列表分页
      pageparms_size_change(val){
        this.pageparms.pageSize=val
        //设备列表
        this.device_list()
      },
      pageparms_current_change(val){
        this.pageparms.currentPage=val
        //设备列表
        this.device_list()
      },
      //绑定设备
      bin_device(row){
        if(!this.bind_form.startTimeStr){
          this.$message.warning('请选择开始时间！')
          return false
        }
        if(!this.bind_form.signBackTimeStr){
          this.$message.warning('请选择返回时间！')
          return false
        }
        if(this.bind_form.startTimeStr>this.bind_form.signBackTimeStr){
          this.$message.warning('开始时间必须小于或等于返回时间')
          return false
        }
        let that=this
        that.$confirm('确定绑定温度计 '+row.deviceId+'/'+row.deviceName+' 吗?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'post',
            url:that.publicAjax.extra_path+'/middle/coldChain/bindingDevice',
            data:{
              deviceId:row.deviceId,
              transactionId:that.row_cold_now.id,
              arriveTime:that.bind_form.startTimeStr,
              backTime:that.bind_form.signBackTimeStr
            },
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              that.device_show=false
              //设备列表
              that.device_list()
              //冷链事务列表
              that.coldChain_list()
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //确认到达时间前置
      confirm_time_pre(){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
        if(this.row_cold_now.deviceId==''){
          this.$message.warning('请先绑定设备！')
          return false
        }
        if(this.row_cold_now.coldChainStatus==3){
          this.$message.warning('已处理状态,不能确认到达！')
          return false
        }
        this.arrive_time_show=true
        this.arrive_form.arriveTime=this.row_cold_now.startTime
      },
      //确认到达时间
      confirm_time(){
        let that=this
        if(that.arrive_form.arriveTime==''){
          that.$message.warning('请选择到达时间')
        }else{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/coldChain/confirmArrived/'+that.row_cold_now.id,
            data:that.arrive_form,
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              that.arrive_time_show=false
              //冷链事务列表
              that.coldChain_list()
            }else{
              that.$message.error(data.data.message)
            }
          })
        }
      },
      //确认当前到达
      confirm_time_now(){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
        if(this.row_cold_now.deviceId==''){
          this.$message.warning('请先绑定设备！')
          return false
        }
        if(this.row_cold_now.coldChainStatus==3){
          this.$message.warning('已处理状态,不能确认到达！')
          return false
        }
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/middle/coldChain/confirmArrived/'+that.row_cold_now.id,
          data:{
            arriveTime:that.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd hh:mm:ss')
          },
          headers:{
            "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"application/json;charset=UTF-8"
          }
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
            //冷链事务列表
            that.coldChain_list()
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //查看温度
      check_temp(){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
        this.savedStatus=this.row_cold_now.coldChainStatus
        // if(!this.row_cold_now.arriveTime){
        //   this.$message.warning('查看温度曲线前必须确认到达时间！')
        //   return false
        // }
        if(!this.row_cold_now.deviceId){
          this.$message.warning('设备还未绑定无法查看温度曲线！')
          return false
        }
        if(!this.row_cold_now.startTime){
          this.$message.warning('查看温度曲线前必须包含开始时间！')
          return false
        }
        if(!this.row_cold_now.orderNo){
          this.$message.warning('查看温度曲线前必须包含订单号！')
          return false
        }
        if(!this.row_cold_now.traceId){
          this.$message.warning('查看温度曲线前必须包含装箱单号！')
          return false
        }
        //保存温度数据是否删除报警信息
        this.$axios({
          method:'get',
          url:this.publicAjax.extra_path+'/admin/dict/select/byCode/alertRecordAfterSaveTempDataLabel'
        }).then(data=>{
          if(data.data.success==true){
            this.save_alert=data.data.data[0].name
          }
        })
        this.isCustom='N'
        //初始化echarts实例
        document.getElementById('chart').removeAttribute('_echarts_instance_')
        this.myChart=this.$echarts.init(document.getElementById('chart'))
        //获取温度数据
        this.get_temp()
      },
      //获取温度数据
      get_temp(){
        this.myChart.clear()
        this.draw_status=false
        this.chart_or_draw=false
        this.draw_title='绘制曲线'
        let that=this
        that.$axios.get(that.publicAjax.extra_path+'/middle/coldChain/tempData/'+that.row_cold_now.deviceId,{
          params:{
            transactionId:that.row_cold_now.id,
            traceId:that.row_cold_now.traceId,
            orderNo:that.row_cold_now.orderNo,
            tempFlag:that.row_cold_now.tempFlag,
            startTime:that.row_cold_now.startTime,
            arriveTime:that.row_cold_now.arriveTime==null?that.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd hh:mm:ss'):that.row_cold_now.arriveTime
          }
        }).then(data=>{
          if(data.data.success==true){
            that.tempData=data.data.data
            let data_temp=data.data.data
            let data_temp_list=data.data.data.recordList
            that.new_temp_list=[]
            //温度上限
            that.maxTemperature=parseFloat(data_temp.maxTemp)
            //温度下限
            that.minTemperature=parseFloat(data_temp.minTemp)
            that.globalCustomFlag=data_temp.isCustom
            if(data_temp_list==null){

            }else if(data_temp_list.length==0){

            }else if(data_temp_list.length>0){

              if(that.globalCustomFlag!='N'){
                let stt2=data_temp_list[0].recordTime
                let att2=data_temp_list[data_temp_list.length-1].recordTime
                let savedStt2=new Date(that.row_cold_now.startTime)
                let savedAtt2=new Date(that.row_cold_now.arriveTime)
                let natt2=new Date(att2)
                natt2.setSeconds(0)
                savedAtt2.setSeconds(0)
                // if(natt2.getTime()!=savedAtt2.getTime()){
                //   that.$message.warning('检查到事务的 到达时间 与已存在温度记录的截至时间不匹配,请联系管理员!')
                //   return false
                // }
              }
              if(data.data.data.nullCount>0){
                that.$message.error('检查到有温度点数据为空，数量为：'+data.data.data.nullCount)
              }
              data_temp_list.forEach(item=>{
                if(item.temperature==null){
                  that.new_temp_list.push([that.publicAjax.genDateFromStamp(item.recordTime),null])
                }else{
                  that.new_temp_list.push([that.publicAjax.genDateFromStamp(item.recordTime),parseFloat(item.temperature).toFixed(1)])
                }
              })
            }
            that.activeName='third'
            //生成折线图
            that.get_myCharts()
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //生成折线图
      get_myCharts(){
        let that=this
        that.curve_temp_list=[]
        var y_max=0
        var y_min=0
        y_max=parseFloat(that.tempData.max)>parseFloat(that.tempData.maxTemp)?parseFloat(that.tempData.max)+2:parseFloat(that.tempData.maxTemp)+2
        y_min=parseFloat(that.tempData.min)<parseFloat(that.tempData.minTemp)?parseFloat(that.tempData.min)-2:parseFloat(that.tempData.minTemp)-2
        let option={
          title:{
            text:that.row_cold_now.traceId+' 的温度记录',
            textAlign:'center',
            x:'center'
          },
          xAxis:{
            type:'category',
            axisLine:{onZero:false},
            showMaxLable:true,//显示最大值
            showMinLable:true,//显示最小值
            axisLabel:{
              formatter:function(value){
                return value.split(' ').join('\n')
              }
            }
          },
          yAxis:{
            type:'value',
            axisLine:{onZero:false},
            max:y_max,//y轴最大值
            min:y_min//y轴最小值
          },
          dataZoom:[
            {
                id: 'dataZoomX',
                type: 'inside',
                xAxisIndex: [0],
                filterMode: 'filter'
            },
            {
                id: 'dataZoomY',
                type: 'inside',
                yAxisIndex: [0],
                filterMode: 'empty'
            },
            {
                id: 'dataZoomXs',
                type: 'slider'
                , show: true
                , xAxisIndex: [0]
                , filterMode: 'filter'
                , textStyle: {
                    color: "#409EFF"
                    , fontWeight: 'lighter'
                    , fontStyle: 'italic'
                    , width: 30
                    , fontSize: 9
                    , overflow: "break"
                }
            },
            {
                id: 'dataZoomYs',
                type: 'slider',
                yAxisIndex: [0],
                filterMode: 'empty'
                , textStyle: {
                    color: "#409EFF", width: '2', overflow: "truncate"
                }
            }
          ],
          series:[
            {
              id:'a',
              type:'line',
              smooth:true,
              symbolSize:10,//为方便拖拽，把尺寸设大
              data:that.new_temp_list
            },
            {//温度下限(有效范围)
              id:'b',
              type:'line',
              smooth:false,
              itemStyle: {
                  normal: {
                      lineStyle: {
                          width: 2,
                          type: 'dotted'  //'dotted'虚线 'solid'实线
                      }
                  }
              },
              data:!that.new_temp_list[0]?[]:[[that.new_temp_list[0][0],parseFloat(that.tempData.minTemp)],[that.new_temp_list[that.new_temp_list.length-1][0],parseFloat(that.tempData.minTemp)]]
            },
            {//温度上限(有效范围)
              id:'c',
              type:'line',
              smooth:false,
              itemStyle: {
                  normal: {
                      lineStyle: {
                          width: 2,
                          type: 'dotted'  //'dotted'虚线 'solid'实线
                      }
                  }
              },
              data:!that.new_temp_list[0]?[]:[[that.new_temp_list[0][0],parseFloat(that.tempData.maxTemp)],[that.new_temp_list[that.new_temp_list.length-1][0],parseFloat(that.tempData.maxTemp)]]
            }
          ],
          tooltip:{
            //表示不使用默认的【显示】【隐藏】触发规则
            axisPointer:{
              type:'cross',
              snap:true,
              label:{
                backgroundColor:'#6a7985',
                precision:1
              }
            },
            formatter:function(params){
              return "温度："+parseFloat(params.data[1]).toFixed(1)+"°c<br>"+params.data[0]
            }
          },
          toolbox:{
            show:true,
            feature:{
              saveAsImage: {
                  show: true,
                  excludeComponents: ['toolbox'],
                  pixelRatio: 2
              }
            }
          }
        }
        that.myChart.setOption(option)
        that.new_temp_list.forEach(item=>{
          that.curve_temp_list.push({
            recordTime:item[0],
            temperature:item[1]
          })
        })
      },
      //返回(取消绘制曲线)
      reBack(){
        this.hasOver='Y'
        this.draw_status=false
        this.draw_title='绘制曲线'
        this.chart_or_draw=false
        this.isMouseDown=false
      },
      //确认(确认所绘制曲线)
      confirmDrawing(){
        if(this.drawXPoint.length<this.totalPoint){//画的节点数小于总数表示没有画完
          this.$message.warning('曲线图尚未完成，不能保存')
          return;
        }
        this.drawYPoint=this.drawYPoint.slice(0,this.totalPoint)
        this.drawXPoint=this.drawXPoint.slice(0,this.totalPoint)
        this.hasOver='Y'
        this.new_temp_list=this.getAllTemperatureDataFromCanvasDrawingBoard()
        this.draw_status=false
        this.draw_title='绘制曲线'
        this.chart_or_draw=false
        this.isMouseDown=false
        this.tempData.max=this.maxTemperature
        this.tempData.min=this.minTemperature
        let that=this
        //清空上一次的图表
        that.flushCharts()
        //生成折线图
        that.get_myCharts()
        that.myChart.setOption({
          series:[{
            id:'a',
            data:that.new_temp_list
          }]
        })
      },
      //获取整条曲线中所有点的温度和时间坐标
      getAllTemperatureDataFromCanvasDrawingBoard(){
        let temperatureList=[]
        for(let i=0;i<this.drawYPoint.length;i++){
          let time=new Date(this.sTime)
          time.setSeconds(time.getSeconds()+this.timeInterval*i)
          //计算当前x轴对应的时间节点
          let x=this.convertDateToYmdhms(time)
          //计算当前y轴坐标对应的温度
          this.maxTemperature=parseFloat(this.maxTemperature)
          this.minTemperature=parseFloat(this.minTemperature)
          let y=((this.canvasHeight - this.drawYPoint[i]) / this.canvasHeight) * (this.maxTemperature - this.minTemperature) + this.minTemperature
          y=parseFloat(y).toFixed(1)
          temperatureList.push([x,y])
        }
        return temperatureList
      },
      //将new Date转为yyyy-mm-dd hh:mm:ss\
      convertDateToYmdhms(sourceDate){
        return sourceDate.getFullYear() + "-" + this.checkTime(sourceDate.getMonth() + 1) + "-" + this.checkTime(sourceDate.getDate()) + " " + this.checkTime(sourceDate.getHours()) + ":" + this.checkTime(sourceDate.getMinutes())
      },
      //日期格式化
      checkTime(i){
        if(i<10){
          i='0'+i
        }
        return i
      },
      //清空上一次的图表
      flushCharts(){
        let lastedOption=this.myChart.getOption()
        if(lastedOption){
          for(let i = 0; i < lastedOption.series.length; i++){
            lastedOption.series[i].data=[]
            lastedOption.series[i].name=''
            lastedOption.title[0].text=''
          }
          this.myChart.clear()
          this.myChart.setOption(lastedOption)
        }
      },
      //绘制曲线
      draw_curve(){
        this.isCustom='Y'
        this.hasOver='N'
        console.log(this.maxTemperature,this.minTemperature)
        if(!this.maxTemperature||!this.minTemperature){
          this.$message.warning('无法获取到设备的上下限温度')
          return false
        }
        if(!this.row_cold_now.arriveTime){
          this.$message.warning('绘制曲线前必须确认到达时间！')
          return false
        }
        this.draw_status=!this.draw_status
        if(this.draw_status==true){
          this.draw_title='取消绘制'
        }else{
          this.draw_title='绘制曲线'
          this.chart_or_draw=false
          return false
        }
        let that=this
        //如果是 冷冻的 手动配置上下限温度
        if(that.row_cold_now.tempFlag=='F'){
          //手动确认温度表单初始化
          that.$confirm('冷冻冷链事务，需要手动确认上下限温度',{
            type:'warning'
          }).then(()=>{
            that.draw_show=true
            // that.$refs['draw_temp_form'].resetFields()
          }).catch(()=>{
            that.hasOver='Y'
            that.draw_status=false
          })
        }else{
          this.draw_show=false
          this.chart_or_draw=true
          //初始化canvas要用到的数据
          this.initcanvas(new Date(this.row_cold_now.startTime),new Date(this.row_cold_now.arriveTime),60,this.minTemperature,this.maxTemperature,50,2,'manualDrawingCanvas')
        }
        return false
      },
      //手动确认温度关闭前的回调
      confirm_temp_close(){
        this.draw_status=false
        this.draw_show=false
      },
      //手动确认温度保存
      confirm_temp_save(){
        let maxT=parseInt(this.draw_temp_form.maxT)
        let minT=parseInt(this.draw_temp_form.minT)
        if(maxT<minT){
          this.$message.warning('下限必须小于上限')
          return false
        }
        this.draw_show=false
        this.chart_or_draw=true
        //初始化canvas要用到的数据
        this.initcanvas(new Date(this.row_cold_now.startTime),new Date(this.row_cold_now.arriveTime),60,this.draw_temp_form.minT,this.draw_temp_form.maxT,50,2,'manualDrawingCanvas')
      },
      //初始化canvas要用到的数据
      //startTime:开始时间
      //endTime:结束时间
      //ti:间隔
      //mint:最小温度
      //maxt::最大温度
      //ml:第一个开始的坐标
      //ia:包容量
      //cvId:canvasJQ对象
      initcanvas(startTime, endTime, ti, mint, maxt, ml, ia, cvId){
        this.sTime=startTime
        this.eTime=endTime
        this.timeInterval=ti
        this.maxTemperature=maxt
        this.minTemperature=mint
        this.marginLeft=ml
        this.inclusiveAmount=ia
        this.canvas=document.getElementById(cvId)
        this.cxt=this.canvas.getContext('2d')
        this.canvasWidth=parseInt(this.canvas.width)
        this.canvasHeight=parseInt(this.canvas.height)
        this.totalPoint=(this.eTime.setSeconds(0)-this.sTime.setSeconds(0))/1000/this.timeInterval+1
        console.log(this.totalPoint)
        this.interval=parseFloat(((this.canvasWidth-100)/this.totalPoint).toFixed(2))
        console.log(this.interval)
        if(this.interval==0){
          this.interval=0.1
        }
        let that=this
        //监听鼠标事件
        that.canvas.addEventListener('mousedown',function(e){
          that.isMouseDown=true
          that.DrawLine(e)
        },false)
        that.canvas.addEventListener('mouseup',function(e){
          that.isMouseDown=false
        },false)
        that.canvas.addEventListener('mousemove',function(e){
          let point=((that.canvasHeight-e.offsetY)/that.canvasHeight)*(that.maxTemperature-that.minTemperature)+that.minTemperature*1
          point=parseFloat(point.toString()).toFixed(2)
          that.mouseCurrentTemp=point
          that.DrawLine(e)
        },false)
        //重置画板
        this.reDrawing()
      },
      //重置画板
      reDrawing(){
        this.isMouseDown=false
        this.canvas.height=this.canvasHeight
        this.drawXPoint=[]
        this.drawYPoint=[]
        this.currentPoint=0
        this.shouldPoint=1
        this.cxt.moveTo(this.marginLeft,0)
        this.cxt.lineTo(this.marginLeft,400)
        this.cxt.stroke()
      },
      //取点画线
      DrawLine(e){
        //当前点不是最后一个点
        let boolFlag=this.currentPoint!=this.totalPoint
        if(boolFlag){
          //离鼠标最近的下一个点
          this.shouldPoint=parseInt((e.offsetX-this.marginLeft)/this.interval)+1
          //上述点的x坐标(shouldpoint-1是因为+marginleft相当于shouldpoint+1)
          this.shouldBeIndex=parseFloat((this.marginLeft+(this.shouldPoint-1)*this.interval).toFixed(2))
          //x坐标是否在上述点附近
          let b1=e.offsetX>=this.shouldBeIndex-this.inclusiveAmount&&e.offsetX<=this.shouldBeIndex+this.inclusiveAmount
          //x坐标是否已经被记录
          let b2=this.drawXPoint.indexOf(this.shouldBeIndex)<0
          //x坐标是否处在允许绘制的区域
          let b3=e.offsetX>=this.marginLeft
          //x坐标是否大于允许绘制的区域
          let b4=e.offsetX>=this.canvasWidth-this.marginLeft
          if(b4){
            this.shouldPoint=this.totalPoint
          }
          if(b1&&b2&&b3&&this.isMouseDown){
            let yIndex=e.offsetY
            let yInterval=0
            if(this.drawYPoint.length>0){
              yIndex=this.drawYPoint[this.drawYPoint.length-1]
              yInterval=(this.drawYPoint[this.drawYPoint.length-1]-e.offsetY)/(this.shouldPoint-this.currentPoint)
            }
            //循环从应该打的点到当前鼠标所在点的所有坐标
            for(let i=0;i<this.shouldPoint-this.currentPoint;i++){
              let itemIndex=parseFloat((this.marginLeft+(this.currentPoint+i)*this.interval).toFixed(2))
              this.drawXPoint.push(itemIndex)
              this.drawYPoint.push((yIndex - yInterval * (i + 1)))
            }
            this.currentPoint=this.shouldPoint
            //刷新canvas
            this.refreshCanvas()
          }
        }
      },
      //刷新canvas
      refreshCanvas(){
        this.canvas.height=this.canvas.height
        console.log(this.canvas.height)
        this.cxt.moveTo(this.drawXPoint[0],this.drawYPoint[0])
        this.cxt.beginPath()
        this.cxt.arc(this.drawXPoint[0],this.drawYPoint[0],1,0,360,false)
        this.cxt.fill()//画实心圆
        for(let i=1;i<this.drawXPoint.length;i++){
          this.cxt.lineTo(this.drawXPoint[i],this.drawYPoint[i])
          this.cxt.stroke()
          this.cxt.beginPath()
          this.cxt.arc(this.drawXPoint[i],this.drawYPoint[i],1,0,360,false)
          this.cxt.fill()//画实心圆
          this.cxt.moveTo(this.drawXPoint[i],this.drawYPoint[i])
        }
        if(this.currentPoint<this.totalPoint){
          //画引导竖线
          this.drawVerticalLine()
        }
      },
      //画引导竖线
      drawVerticalLine(){
        this.cxt.moveTo(this.shouldBeIndex+this.interval,0)
        this.cxt.lineTo(this.shouldBeIndex+this.interval,400)
        this.cxt.stroke()
        this.cxt.moveTo(this.drawXPoint[this.drawXPoint.length-1],this.drawYPoint[this.drawYPoint.length-1])
      },
      //将base64转换为file
      dataURLtoFile(dataurl,filename){
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bStr = atob(arr[1]), n = bStr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bStr.charCodeAt(n)
        }
        return new File([u8arr], filename, {type: mime})
      },
      //保存绘制的数据
      save_data(){
        if(this.savedStatus==1||this.savedStatus==3){
          this.$message.warning('只有未处理或待处理时可以确认温度！')
          return false
        }
        // if(this.chart_or_draw==false){
        //   this.$message.warning('没有需要保存的记录！')
        //   return false
        // }
        if(this.isCustom=='Y'&&this.hasOver=='N'){
          this.$message.warning('请先点击确认按钮，再保存')
          return false
        }
        if(this.globalCustomFlag=='Y'){
          this.isCustom='Y'
        }
        let that=this
        that.$confirm('确定保存温度数据么?',{
          type:'warning'
        }).then(()=>{
          // let picInfo=that.myChart.getDataURL({
          //   type:'png',
          //   pixelRatio:1.5,
          //   backgroundColor:"#fff"
          // })
          // let img=that.dataURLtoFile(picInfo,'testImg.png')
          // let formData=new FormData()
          // formData.append('file',img)
          // that.$axios({
          //   method:'post',
          //   url:that.publicAjax.extra_path+'/sccOwn/upload/image/coldTempChart',
          //   data:formData,
          //   headers:{
          //     "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
          //     "content-type":"multipart/form-data"
          //   }
          // }).then(data=>{
          //   if(data.data.success==true){
          //     let url_list=data.data.data
          //     that.imgUrl=url_list[0].url
          //     that.md5=url_list[0].md5
          //   }else{
          //     that.$message.error(data.data.message)
          //   }
          // }).catch(err=>{

          // })
          that.had_temp_form.fp=parseFloat(that.new_temp_list[0][1]).toFixed(1)
          that.had_temp_form.lp=parseFloat(that.new_temp_list[that.new_temp_list.length-1][1]).toFixed(1)
          if(isNaN(that.had_temp_form.lp)){
            that.had_temp_form.lp=parseFloat(that.new_temp_list[that.new_temp_list.length-2][1]).toFixed(1)
          }
          //指定第一个以及最后一个点的温度
          that.had_temp_show=true
        }).catch(()=>{

        })
      },
      //强制保留一位小数
      isDoubleDecimal(numb){
        if(!isNaN(parseFloat(numb))){
          let dot=numb.indexOf(".")
          if(dot!=-1){
            let dotCnt=numb.substring(dot+1,numb.length)
            return dotCnt.length==1
          }
          return false
        }
        return false
      },
      //确认始末温度
      had_temp_close(){
        this.had_temp_show=false
      },
      confirm_had_temp(){
        if(!this.isDoubleDecimal(this.had_temp_form.fp)){
          this.$message.warning('温度必须是1位小数,例如-10.2')
        }else if(!this.isDoubleDecimal(this.had_temp_form.lp)){
          this.$message.warning('温度必须是1位小数,例如10.5')
        }else{
          if(!this.new_temp_list||!this.new_temp_list.length){
            this.$message.warning('错误，温度数据为空！')
            return false
          }
          let st=this.new_temp_list[0][0]
          let at=this.new_temp_list[this.new_temp_list.length-1][0]
          let stt=new Date(st)
          let att=new Date(at)
          let savedStt=new Date(this.row_cold_now.startTime)
          let savedAtt=new Date(this.row_cold_now.arriveTime)
          att.setSeconds(0)
          savedAtt.setSeconds(0)
          if(!(att.getTime()==savedAtt.getTime())){
            this.$message.warning('事务的到达时间与温度数据的截止时间不一致，请刷新页面后重新操作!')
            return false
          }
          let temps=[]
          for(let i=0;i<this.new_temp_list.length;i++){
            let temp={}
            let recordTimeOfBased=this.new_temp_list[i][0]
            temp.recordTime=Date.parse(new Date(recordTimeOfBased).toString())
            temp.temperature=this.new_temp_list[i][1]
            if(i==0){
              temp.temperature=this.had_temp_form.fp
            }
            if(i==this.new_temp_list.length-1){
              temp.temperature=this.had_temp_form.lp
            }
            temps.push(temp)
          }
          let postSavedJson={
            'deviceId':this.row_cold_now.deviceId,
            'minTemp':this.minTemperature,
            'maxTemp':this.maxTemperature,
            'recordList':temps,
            'transactionId':this.row_cold_now.id,
            'suffix':this.row_cold_now.suffix==null?'2020':this.row_cold_now.suffix,
            // 'imageMd5':this.md5,
            // 'imageUrl':this.imgUrl,
            'orderNo':this.row_cold_now.orderNo.trim(),
            'isCustom':this.isCustom,
            'startTime':this.row_cold_now.startTime,
            'returnTime':this.row_cold_now.arriveTime,
            'traceId':this.row_cold_now.traceId,
            'delAlert':this.save_alert
          }
          let that=this
          this.$axios({
            method:'post',
            url:that.publicAjax.extra_path+'/middle/coldChain/exactTempData',
            data:JSON.stringify(postSavedJson),
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            console.log(data)
            if(data.data.success==true){
              that.$message.success('记录已保存')
              that.had_temp_show=false
              //重载冷链事务列表
              that.pageparm.currentPage=1
              that.pageparm.pageSize=50
              that.coldChain_list()
              that.savedStatus=3
              //更新画布
              //获取温度数据
              this.get_temp()
              return false
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }
      },
      //导出温度数据
      export_data(){
        if(this.savedStatus!=3){
          this.$message.warning('未找到温度数据,请确认!')
          return false
        }
        // if(!this.row_cold_now.id||!this.row_cold_now.suffix){
        //   return false
        // }
        //导出温度数据弹框
        this.export_data_show=true
        this.export_data_title='导出'+this.row_cold_now.traceId+'的温度数据'
        this.export_data_form={
          time:5,
          sF:this.row_cold_now.startTime,
          toto:this.row_cold_now.arriveTime
        }
        //导出echarts实例
        let that=this
        setTimeout(()=>{
          document.getElementById('export_chart').removeAttribute('_echarts_instance_')
          this.export_chart=this.$echarts.init(document.getElementById('export_chart'))
          this.export_chart.clear()
        },100)
      },
      //获取温度计曲线明细数据
      get_temperature_list(){
        this.curve_temp_show=true
        if(this.curve_temp_list.length==1){
          this.curve_temp_data=this.curve_temp_list[0]
        }else if(this.curve_temp_list.length>1){
          this.curve_temp_data=this.curve_temp_list
        }
      },
      //获取冷链车曲线明细数据
      get_truck_list(){
        this.curve_truck_show=true
        if(this.curve_truck_list.length==1){
          this.curve_truck_data=this.curve_truck_list[0]
        }else if(this.curve_truck_list.length>1){
          this.curve_truck_data=this.curve_truck_list
        }
      },
      calculate(date1,date2){
        let ed=this.new_temp_list
        let firstP=ed[0]
        let lastP=ed[ed.length-1]
        //计算有几个点
        let firstDateOfP=firstP[0]
        let lastDateOfP=lastP[0]
        let fDateOfP=new Date(firstDateOfP)
        let lDateOfP=new Date(lastDateOfP)
        let pointsCount=this.getMinutes(lDateOfP,fDateOfP)
        //根据选择日期计算新的数组内容
        let chosenSt=new Date(date1)
        let chosenAt=new Date(date2)
        let stm=this.getMinutes(chosenSt,lDateOfP)
        let atm=this.getMinutes(chosenAt,lDateOfP)
        let newEd=ed.slice(ed.length - stm - 1, ed.length - atm)
        return newEd
      },
      getMinutes(fd,ad){
        return (Math.abs(ad-fd)/1000/60)
      },
      //查看要导出的曲线数据
      check_export_data(){
        //导出echarts实例
        document.getElementById('export_chart').removeAttribute('_echarts_instance_')
        this.export_chart=this.$echarts.init(document.getElementById('export_chart'))
        let newEchartsData=this.calculate(this.export_data_form.sF,this.export_data_form.toto)
        //根据新的数据渲染echars
        this.genChart(newEchartsData)
        return false
      },
      //导出曲线数据成pdf
      export_data_pdf(){
        //导出echarts实例
        this.export_chart=this.$echarts.init(document.getElementById('export_chart'))
        let that=this
        // let picInfo=this.export_chart.getDataURL({
        //   type:'png',
        //   pixelRatio:1.5,
        //   backgroundColor:'#fff'
        // })
        // let img=this.dataURLtoFile(picInfo,'testImg.png')
        // let formData=new FormData()
        // formData.append('file',img)
        // that.$axios({
        //   method:'post',
        //   url:that.publicAjax.extra_path+'/sccOwn/upload/image/coldTempChart',
        //   data:formData,
        //   headers:{
        //     "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
        //     "content-type":"multipart/form-data"
        //   }
        // }).then(data=>{
        //   if(data.data.success==true){
        //     let url_list=data.data.data
        //     let new_imgUrl=url_list[0].url
        //     let new_md5=url_list[0].md5
        //   }else{
        //     that.$message.error(data.data.message)
        //   }
        // })
        //触发导出
        let url=that.publicAjax.extra_path+'/middle/coldChain/export/pdf/'
        let gap=that.export_data_form.time
        let stTime=that.export_data_form.sF
        let edTime=that.export_data_form.toto
        let ex_href=
        url+that.row_cold_now.id+'/2020'
        that.$axios({
          url:ex_href,
          method:'get',
          responseType:'blob',
          params:{
            gap:gap,
            startTime:stTime,
            arriveTime:edTime,
            // imageUrl:new_imgUrl,
            // imageMd5:new_md5
          }
        }).then(data=>{
          that.pdfUrl=window.URL.createObjectURL(new Blob([data.data], {type:"application/pdf"}))
          let link=document.createElement('a')
          link.href=that.pdfUrl
          link.style.display='none'
          let fname=that.row_cold_now.traceId+'.pdf'
          link.setAttribute('download',fname)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        })
      },
      //导出曲线数据函数
      genChart(ecData){
        let that=this
        var y_max=0
        var y_min=0
        y_max=parseFloat(that.tempData.max)>parseFloat(that.tempData.maxTemp)?parseFloat(that.tempData.max)+2:parseFloat(that.tempData.maxTemp)+2
        y_min=parseFloat(that.tempData.min)<parseFloat(that.tempData.minTemp)?parseFloat(that.tempData.min)-2:parseFloat(that.tempData.minTemp)-2
        let option={
          title:{
            text:that.row_cold_now.traceId,
            textAlign:'center',
            x:'center'
          },
          xAxis:{
            type:'category',
            axisLine:{onZero: false},
            showMaxLable:true,//显示最大值
            showMinLable:true,//显示最小值
            axisLabel:{
              formatter:function(value){
                return value.split(' ').join('\n')
              }
            }
          },
          yAxis:{
            type:'value',
            axisLine:{onZero: false},
            max:y_max,//y轴最大值
            min:y_min//y轴最小值
          },
          dataZoom:[
            {
                id: 'dataZoomX',
                type: 'inside',
                xAxisIndex: [0],
                filterMode: 'filter'
            },
            {
                id: 'dataZoomY',
                type: 'inside',
                yAxisIndex: [0],
                filterMode: 'empty'
            },
            {
                id: 'dataZoomXs',
                type: 'slider'
                , show: true
                , xAxisIndex: [0]
                , filterMode: 'filter'
                , textStyle: {
                    color: "#007dff"
                    , fontWeight: 'lighter'
                    , fontStyle: 'italic'
                    , width: 30
                    , fontSize: 9
                    , overflow: "break"
                }
            },
            {
                id: 'dataZoomYs',
                type: 'slider',
                yAxisIndex: [0],
                filterMode: 'empty'
                , textStyle: {
                    color: "#007dff", width: '2', overflow: "truncate"
                }
            }
          ],
          series:[
            {
              id:'a',
              type:'line',
              smooth:true,
              symbolSize:10,
              data:ecData
            },
            {//温度下限(有效范围)
              id:'b',
              type:'line',
              smooth:false,
              itemStyle:{
                normal:{
                  lineStyle:{
                    width:2,
                    type:'dotted'
                  }
                }
              },
              data:!ecData[0]?[]:[[ecData[0][0],parseFloat(that.tempData.minTemp)],[ecData[ecData.length-1][0],parseFloat(that.tempData.minTemp)]]
            },
            {//温度上限(有效范围)
              id:'c',
              type:'line',
              smooth:false,
              itemStyle:{
                normal:{
                  lineStyle:{
                    width:2,
                    type:'dotted'
                  }
                }
              },
              data:!ecData[0]?[]:[[ecData[0][0],parseFloat(that.tempData.maxTemp)],[ecData[ecData.length-1][0],parseFloat(that.tempData.maxTemp)]]
            }
          ],
          tooltip:{
            axisPointer:{
              type:'cross',
              label:{
                backgroundColor:'#6a7985',
                precision:1
              }
            },
            formatter:function(params){
              return "温度："+parseFloat(params.data[1]).toFixed(1)+"°c<br>"+params.data[0]
            }
          },
          toolbox:{
            show:true,
            feature:{
              saveAsImage:{
                show:true,
                excludeComponents:['toolbox'],
                pixelRatio:2
              }
            }
          }
        }
        that.export_chart.setOption(option)
      },
      //添加到批次(自定义菜单的点击事件)
      info_click(event){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
        let selected_rows=this.$refs.manage_table.selection
        if(selected_rows.length<=0){
          this.$message.warning('请勾选左侧复选框,勾选需要添加到批次的事务。')
          return false
        }
        this.lotList=[]
        selected_rows.forEach((item,index)=>{
          this.lotList.push(item.id)
        })
        //批次弹框
        this.insert_batch_show=true
        //批次列表
        this.batch_current_page=1
        this.batch_page_size=10
        this.get_batch_list()
      },
      //批次列表分页
      batch_size_change(val){
        this.batch_page_size=val
        //批次列表
        this.get_batch_list()
      },
      batch_current_change(val){
        this.batch_current_page=val
        //批次列表
        this.get_batch_list()
      },
      //批次列表
      get_batch_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/coldChainLot/list',
          params:{
            page:that.batch_current_page,
            limit:that.batch_page_size
          }
        }).then(data=>{
          if(data.data.success==true){
            that.batch_list=data.data.data.list
            that.batch_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //创建新的批次
      create_batch(){
        if(!this.batch_name){
          this.$message.warning('您还未输入批次名!')
          return false
        }
        let that=this
        that.$axios({
          method:'post',
          url:that.publicAjax.extra_path+'/middle/coldChainLot',
          data:{
            lotName:that.batch_name
          },
          headers:{
            "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"application/json;charset=UTF-8"
          }
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
            //批次列表
            that.get_batch_list()
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      // 批次列表鼠标左键点击事件
      batch_left_click(row,column,event){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
      },
      //批次列表鼠标右键点击事件
      batch_right_click(row,column,event){
        this.row_batch_now=row
        var menu=document.querySelector('#batch_menu')
        event.preventDefault()
        //根据事件对象中鼠标点击的位置，进行定位
        let menu_top=document.body.clientHeight-event.clientY
        if(menu_top<150){
          menu.style.top=event.clientY-40+'px'
        }else{
          menu.style.top=event.clientY+60+'px'
        }
        menu.style.left=event.clientX-200+'px'
        //改变自定义菜单的显示和隐藏
        menu.style.display='block'
        this.$refs.batch_table.setCurrentRow(row)
      },
      //添加到该批次
      add_now_batch(){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
        let that=this
        that.$confirm('确定添加到该批次吗?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'post',
            url:that.publicAjax.extra_path+'/middle/coldChainLot/detail/'+that.row_batch_now.id,
            data:JSON.stringify(that.lotList),
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              //批次列表
              that.get_batch_list()
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .search_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .search_form .el-form-item:last-child{
    width: 100%;
  }
  @media screen and (max-width:720px) {
    .search_form .el-form-item{
      width: 100%;
    }
  }
  /* 右键菜单 */
  #menu,#truck_menu{
    position: fixed;
    display: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background: #FFFFFF;
    cursor: pointer;
    color: #606266;
    width: 200px;
    border: 1px solid #e4e7ed;
    font-size: 14px;
    z-index: 999;
  }
  #batch_menu{
    position: absolute;
    display: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background: #FFFFFF;
    cursor: pointer;
    color: #606266;
    width: 200px;
    border: 1px solid #e4e7ed;
    font-size: 14px;
    z-index: 999;
  }
  #menu ul,#batch_menu ul,#truck_menu ul{
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
  #menu ul li,#batch_menu ul li,#truck_menu ul li{
    padding: 0px 10px;
    height: 30px;
    line-height: 30px;
    position: relative;
    box-sizing: border-box;
    text-indent: 8px;
  }
  #menu ul li:hover,#batch_menu ul li:hover,#truck_menu ul li:hover{
    background-color: #ecf5ff;
  }
  /* 绑定温度计弹框 */
  .bind_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  /* 确认到达时间弹框 */
  .arrive_form .arrive_form_btn{
    display: flex;
    justify-content: flex-end;
  }
  /* 温度数据 */
  #chart{
    width: 1000px;
    height: 550px;
    margin-left: -10px;
    zoom: 1.25;
  }
  .chart_btn_group{
    position: absolute;
    right: 0px;
    top: 20px;
    padding: 0 5px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .chart_btn_group i{
    cursor: pointer;
    font-size: 30px;
    margin-bottom: 20px;
  }
  .chart_btn_group .el-switch{
    margin-bottom: 20px;
  }
  .chart_btn_group .el-icon-edit{
    color: #409EFF;
  }
  /* 绘制曲线样式 */
  .draw_edit_ture{
    font-style: normal;
    color: #131974 !important;
    font-weight: bold;
  }
  /* 要导出的温度数据 */
  #export_chart{
    width: 90%;
    height: 550px;
  }
  .export_dialog{
    zoom: 1.25;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/manage.vue